import { Option, Schema as Schema_ } from '@blade/std-lib'
import { Network } from '@root/entities/network/model'

import * as TradeSettingsPreset from './trade-settings-preset'
import * as TradeSettingsQuick from './trade-settings-quick'

import type { TradeSettingsListData } from '@blade/trade-api-client'

const PresetsSchema = Schema_.Struct({
  presets: Schema_.Array(TradeSettingsPreset.Schema),
  activePresetIndex: Schema_.Number,
  quickAmounts: TradeSettingsQuick.Schema,
})
export interface Presets extends Schema_.Schema.Type<typeof PresetsSchema> {}

export const Schema = Schema_.Struct({
  [Network.Solana]: PresetsSchema,
  [Network.Ethereum]: PresetsSchema,
  [Network.Ton]: PresetsSchema,
  [Network.Base]: PresetsSchema,
  [Network.Bsc]: PresetsSchema,
})

export interface PresetsByNetwork extends Schema_.Schema.Type<typeof Schema> {}

const FromJson = Schema_.fromJsonString(Schema)

export const fromJson = (json: string) => {
  return Option.getOrUndefined(Schema_.decodeOption(FromJson)(json))
}

export const toJson = (settings: PresetsByNetwork) => {
  return Option.getOrUndefined(Schema_.encodeOption(FromJson)(settings))
}

type ByNetworkDto = TradeSettingsListData
export const fromDto = (dto: ByNetworkDto) => {
  const byNetwork = Network.byNetworkRecord((network) => {
    const networkDto = Network.toDto(network)
    const presetsDto = dto[networkDto]
    return presetsFromDto(presetsDto, network)
  })

  return byNetwork
}

export const presetsFromDto = (
  dto: TradeSettingsListData['sol' | 'eth' | 'ton' | 'base' | 'bsc'],
  network: Network.Network,
): Presets => {
  return {
    activePresetIndex: dto.activePreset,
    presets: dto.presets.map((preset, index) =>
      TradeSettingsPreset.fromDto(preset, index, network),
    ),
    quickAmounts: TradeSettingsQuick.fromDto(dto.quickAmounts),
  }
}
